export interface MessagePageProps {
  className?: string;
}

export enum MessagePageType {
  TechnicalError = 'technical-error',
  LinkExpired = 'link-expired',
  SessionExpired = 'session-expired-by-ui',
}
